

(function(global){

  var scrollTo = function(x,y) {
    window.scroll(x, y);
  };

  module.exports = {
    scrollTo: scrollTo
  };

})(this);